import { Col, Container, Row } from "react-bootstrap";
import AdditionalServiceForm from "../../../Components/Forms/AdditionalServiceForm/AdditionalServiceForm";
import { navigateTo } from "../../../redux/router/routerActions";
import { useAppDispatch } from "../../../redux/store";
import { useAddNewAdditionalServiceMutation } from "../../../services/bClientApi";

export default function AddAdditionalServicePage() {

  const [
    addNewAdditionalService,
    {
      isLoading,
      error
    }
  ] = useAddNewAdditionalServiceMutation()

  const dispatch = useAppDispatch()
  const handleSubmit = async (data: any) => {
    const values: any = {
      ...data
    }
    const newAdditionalService = await addNewAdditionalService(values).unwrap()
    if (newAdditionalService._id) {
      dispatch(navigateTo(`/additional-services/${newAdditionalService._id}`))
    }
    return newAdditionalService
  }

  return (
    <Container>
      <Row>
        <Col>
          <h1>Add Additional Service</h1>
          <hr />
          {error && (<>{JSON.stringify(error)}<br /></>)}

          <AdditionalServiceForm
            initialValues={{
                serviceType: '',
                serviceSubType: '',
                status: 'pending',
                price: 0,
            }}
            disabled={isLoading}
            onSubmit={handleSubmit}
          />

        </Col>
      </Row>
    </Container>
  )
}
